import React, { useState } from 'react';
import { NavMenu } from '../NavMenu';
import { AppContainer, NavOverlay, PageContent } from './Layout.styles';

export const Layout = ({ children }) => {
  const [navMenuIsOpen, setNavMenuIsOpen] = useState(false);

  return (
    <AppContainer>
      <NavOverlay navMenuIsOpen={navMenuIsOpen} />
      <NavMenu setNavMenuIsOpen={setNavMenuIsOpen} />
      <PageContent>
        {children}
      </PageContent>
    </AppContainer>
  );
};
